// extracted by mini-css-extract-plugin
export default {"Hinzufügen":"Hinzufügen_Hinzufügen__mNgMj","GR":"Hinzufügen_GR__clNdN","EN":"Hinzufügen_EN__ZYW1C","FR":"Hinzufügen_FR__FnH9K","Footer":"Hinzufügen_Footer__-vfHP"};